import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDemoCtx } from './DemoContext';

export default function DemoJoin() {
    const [step, setStep] = useState(1);
    const [pwBars, setPwBars] = useState([0, 0, 0, 0]);
    const [pwHint, setPwHint] = useState('비밀번호를 입력해주세요');
    const [showPw, setShowPw] = useState(false);
    const [bizMsg, setBizMsg] = useState<{ type: 'ok' | 'fail'; text: string } | null>(null);
    const [emailHint, setEmailHint] = useState<{ ok: boolean; text: string } | null>(null);
    const [checked, setChecked] = useState([false, false, false]);
    const navigate = useNavigate();
    const { toast } = useDemoCtx();

    const checkPw = (v: string) => {
        let sc = 0;
        if (v.length >= 8) sc++;
        if (/[A-Za-z]/.test(v)) sc++;
        if (/[0-9]/.test(v)) sc++;
        if (/[^A-Za-z0-9]/.test(v)) sc++;
        setPwBars([sc > 0 ? sc : 0, sc > 1 ? sc : 0, sc > 2 ? sc : 0, sc > 3 ? sc : 0]);
        const msgs = ['', '너무 약한 비밀번호', '보통 수준 비밀번호', '강한 비밀번호 ✓', '매우 강한 비밀번호 ✓✓'];
        setPwHint(msgs[sc] || '비밀번호를 입력해주세요');
    };

    const barClass = (i: number) => {
        const s = pwBars[i];
        if (s === 0) return 'pw-bar';
        if (s <= 1) return 'pw-bar weak';
        if (s <= 2) return 'pw-bar medium';
        return 'pw-bar strong';
    };

    const submit = () => {
        if (!checked[0] || !checked[1]) { toast('필수 약관에 동의해주세요', 'error'); return; }
        toast('가입 신청이 완료되었습니다!', 'success');
        setTimeout(() => navigate('/demo/pending'), 650);
    };

    const toggleCheck = (i: number) => setChecked(p => p.map((v, idx) => idx === i ? !v : v));

    return (
        <div className="gmw gmw-auth" style={{ overflowY: 'auto' }}>
            <div className="auth-logo" onClick={() => navigate('/demo/login')} style={{ cursor: 'pointer' }}>
                <div className="auth-logo-mark">🌿</div>
                <div className="auth-logo-name">Tree<em>Map</em></div>
            </div>

            {step === 1 ? (
                <div className="auth-card auth-card-wide fade-up">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                        <div className="auth-card-title">회원가입</div>
                        <span style={{ fontSize: 12.5, color: 'var(--text3)', fontWeight: 600 }}>1 / 2 단계</span>
                    </div>
                    <div className="auth-card-sub">회사 정보를 입력해주세요. 관리자 승인 후 서비스 이용이 가능합니다.</div>
                    <div className="auth-step-bar">
                        <div className="auth-step-seg active" />
                        <div className="auth-step-seg" />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                        <div className="form-group">
                            <label className="form-label">회사명 <span style={{ color: 'var(--danger)' }}>*</span></label>
                            <input type="text" className="form-input" placeholder="(주)그린조경개발" />
                            <div className="form-hint">2자 이상 50자 이하</div>
                        </div>
                        <div className="form-group">
                            <label className="form-label">사업자등록번호 <span style={{ color: 'var(--danger)' }}>*</span></label>
                            <div className="biz-row">
                                <input type="text" className="form-input" placeholder="000-00-00000" maxLength={12} />
                                <button className="btn btn-secondary" onClick={() => setBizMsg({ type: 'ok', text: '✓ 정상 사업자번호 확인' })}>인증</button>
                            </div>
                            {bizMsg && <div className={`verify-msg ${bizMsg.type}`}>{bizMsg.text}</div>}
                        </div>
                        <div className="form-row">
                            <div className="form-group"><label className="form-label">대표자명 <span style={{ color: 'var(--danger)' }}>*</span></label><input type="text" className="form-input" placeholder="홍길동" /></div>
                            <div className="form-group"><label className="form-label">회사 연락처 <span style={{ color: 'var(--danger)' }}>*</span></label><input type="tel" className="form-input" placeholder="02-0000-0000" /></div>
                        </div>
                        <div className="form-group">
                            <label className="form-label">회사 주소 <span style={{ color: 'var(--danger)' }}>*</span></label>
                            <div style={{ display: 'flex', gap: 8, marginBottom: 7 }}>
                                <input type="text" className="form-input" placeholder="우편번호" style={{ width: 130, flexShrink: 0 }} readOnly />
                                <button className="btn btn-secondary" onClick={() => toast('카카오 우편번호 API 연동', 'success')}>주소 검색</button>
                            </div>
                            <input type="text" className="form-input" placeholder="기본 주소" style={{ marginBottom: 7 }} />
                            <input type="text" className="form-input" placeholder="상세 주소 입력" />
                        </div>
                        <button className="btn btn-primary btn-lg w-full" onClick={() => setStep(2)}>다음 단계 →</button>
                        <div className="auth-footer">이미 계정이 있으신가요? <a onClick={() => navigate('/demo/login')}>로그인</a></div>
                    </div>
                </div>
            ) : (
                <div className="auth-card auth-card-wide fade-up">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                        <div className="auth-card-title">관리자 계정 설정</div>
                        <span style={{ fontSize: 12.5, color: 'var(--text3)', fontWeight: 600 }}>2 / 2 단계</span>
                    </div>
                    <div className="auth-card-sub">플랫폼을 관리할 관리자 계정 정보를 입력해주세요</div>
                    <div className="auth-step-bar">
                        <div className="auth-step-seg done" />
                        <div className="auth-step-seg active" />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                        <div className="form-row">
                            <div className="form-group"><label className="form-label">관리자 이름 <span style={{ color: 'var(--danger)' }}>*</span></label><input type="text" className="form-input" placeholder="홍길동" /></div>
                            <div className="form-group"><label className="form-label">직책</label><select className="form-select"><option>선택</option><option>대표</option><option>팀장</option><option selected>관리자</option><option>현장관리자</option></select></div>
                        </div>
                        <div className="form-group">
                            <label className="form-label">이메일 <span style={{ color: 'var(--danger)' }}>*</span></label>
                            <div style={{ display: 'flex', gap: 8 }}>
                                <input type="email" className="form-input" placeholder="admin@company.com" onChange={e => {
                                    const v = e.target.value;
                                    setEmailHint(v && v.includes('@') ? { ok: true, text: '✓ 사용 가능한 이메일입니다' } : null);
                                }} />
                                <button className="btn btn-secondary" onClick={() => setEmailHint({ ok: true, text: '✓ 사용 가능한 이메일입니다' })}>중복확인</button>
                            </div>
                            {emailHint ? (
                                <div className={`form-hint${emailHint.ok ? ' ok' : ''}`}>{emailHint.text}</div>
                            ) : (
                                <div className="form-hint">이메일로 서비스 로그인 및 알림을 받게 됩니다</div>
                            )}
                        </div>
                        <div className="form-group">
                            <label className="form-label">비밀번호 <span style={{ color: 'var(--danger)' }}>*</span></label>
                            <div className="pw-wrap">
                                <input type={showPw ? 'text' : 'password'} className="form-input" placeholder="8자 이상, 영문+숫자+특수문자" onChange={e => checkPw(e.target.value)} />
                                <button className="pw-eye" onClick={() => setShowPw(p => !p)}>{showPw ? '🙈' : '👁'}</button>
                            </div>
                            <div className="pw-strength">
                                {[0,1,2,3].map(i => <div key={i} className={barClass(i)} />)}
                            </div>
                            <div className="form-hint" style={{ color: pwBars[0] <= 1 ? 'var(--danger)' : pwBars[0] <= 2 ? 'var(--warn)' : 'var(--good)' }}>{pwHint}</div>
                        </div>
                        <div className="form-group">
                            <label className="form-label">비밀번호 확인 <span style={{ color: 'var(--danger)' }}>*</span></label>
                            <input type="password" className="form-input" placeholder="비밀번호 재입력" />
                        </div>
                        <div className="terms-box">
                            {['(필수) 이용약관에 동의합니다', '(필수) 개인정보처리방침에 동의합니다', '(선택) 마케팅 정보 수신에 동의합니다'].map((txt, i) => (
                                <label key={i} className={`check-wrap${checked[i] ? ' checked' : ''}`} onClick={() => toggleCheck(i)}>
                                    <span className="check-box" />
                                    <span className="check-label">{txt}</span>
                                </label>
                            ))}
                        </div>
                        <div style={{ display: 'flex', gap: 10 }}>
                            <button className="btn btn-secondary btn-lg" onClick={() => setStep(1)}>← 이전</button>
                            <button className="btn btn-primary btn-lg w-full" onClick={submit}>가입 신청 완료</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
